<div>
  <ng-container><span class="utilization-display">{{showUtilization === true ? (utilization | percent) : '-' }}</span></ng-container>
  <br />
  <ng-container><span class="hours-display">{{showWorked ? hoursWorked + 'h' : '-'}} | {{showWanted === true ? hoursWanted + 'h' : '-'}} </span></ng-container>
</div>
